module.exports = __webpack_public_path__ + "img/ny_kitchen_sigLogo_cropped.0943d9f4.jpg";